const ModuleIdentifierConst = {
  RULES: 'rulesManagement',
  RULE: 'rulesList',
  RULE_GROUP: 'ruleGroupsList',
  RULE_PLAN: 'rulePlansList',
  FREQUENCY: 'frequencyMasterManagement',
  PAYOUT_FREQUENCY: 'payoutFrequency',
  WORKFLOW: 'workflowMasterManagement',
  PROGRAM: 'configureProgramManagement',
  TARGET_SETTING_CONFIG_MANAGEMENT: 'targetSettingConfigManagement',
  HOLIDAY: 'fileManagement',
  TARGET_HIERARCHY_MANAGEMENT: 'targetHierarchyManagement',
  CATEGORY: 'categoryManagement',
  UPLOAD_PRODUCT_IMAGE: 'uploadProductImageList',
  CONTEST: 'contestManagement',
  QUERYCONFIG: 'QueryConfigMangement',
  RULE_WORKFLOW: 'gridApprovalWorkflowList',
  BULK_RULE: 'ruleBulkUploadManagement',
  QUERY: 'queryManagement',
};

export default ModuleIdentifierConst;
